module.exports = __webpack_public_path__ + "img/icn_brand5.9ab6aacc.svg";